import React, { useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from '../../../../Model/Network/Config/Axios';
import { Modal } from '../../fModal/Modal';
import { showToast } from '../../fToast/ToastCallback';
import { getUploadUrl } from '../../../../Model/Network/Config/DecentralizeWrapper';


const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const focusedStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

function MultipleAttachmentUploaderModal(props) {


  const [attachments, setAttachments] = useState([]);
  const [modal,setModal] = useState(false);
  const [buttonLoading,setButtonLoading] = useState(false);
  const onDrop = (acceptedFiles) => {
    setAttachments([...attachments, ...acceptedFiles]);
  };
  const { getRootProps, getInputProps,isFocused,isDragAccept,isDragReject } = useDropzone({ 
    onDrop, 
    multiple: true,
    maxSize:50000000,
    accept: '.jpg,.jpeg,.pdf,.png,.xlsx,.csv,.eml'
  });


  

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ]);


  const handleSubmit = async () => {


    if(!attachments.length) {
        showToast({
          type:'error',
          message:"Please select atleast 1 attachment"
        })
        return;
    }

    setButtonLoading(true);
    let tempItems = [];
    for (let i = 0; i < attachments.length; i++) {
      const formData = new FormData();
      formData.append('attachments[]', attachments[i]);
      const url = await axios({
        method: 'post',
        url: getUploadUrl(),
        data: formData,
      })
        .then(res => {
          return res.data.url
        })
        .catch(()=>{
          
        })
         tempItems.push({
          url,
          name:attachments[i].name
         });
        if(tempItems.length===attachments.length) {
           setButtonLoading(false);
           props.onUpload(tempItems);
           setModal(false);
           setAttachments([]);
           
        }
      
    }

   

    
  };



  return (

    <>
    
    <label  onClick={()=>{
        setModal(true)
    }} style={{width: '70px', height: '70px', fontSize: "24px", color: '#666', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', margin: '7px', cursor: 'pointer', borderRadius: '15px', border: '1px dashed #666',backgroundImage: `url('${props.type==='Mono'?File:''}')`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}}>
		<svg style={{ verticalAlign: "middle"}} className="bi bi-plus-circle" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
		        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
		</svg>
	</label>	
  {modal &&
     <Modal 
        title="Upload"
        show={modal}
        close={()=>{
            setModal(false)
        }}
        des="Select the file you want to upload"
        onSave={()=>{
           handleSubmit();
        }}
        stateLoading={buttonLoading}
        buttonName="Upload Document"
        zIndex={{
          zIndex:100000
        }}
    >
      <div {...getRootProps({style})}>
        <input 
          {...getInputProps()} 
          accept=".jpg,.jpeg,.pdf,.png,.xlsx,.csv,.eml,.txt,.docx,.doc"

          />
        <p>Drag and drop some files here, or click to select files</p>
        <ul>
          {attachments.map((attachment, index) => (
            <li key={index}>{attachment.name}</li>
          ))}
        </ul>
      </div>
    </Modal>
    
  }
    </>
   
  );
}

export {MultipleAttachmentUploaderModal}
